const submitToSalesForce = (payload, state = {}) => {
    const campaignMap = {
        "free_trial": "701Ul00000Labl2",
        "starter": "701Ul00000LamA9",
        "growth": "701Ul00000LavOf",
        "enterprise": "701Ul00000Lajgs",
        "ai-creator": "701Ul00000Lavmr",
        "pdp": "701Ul00000Lx4RmIAJ",
        "email": "701Ul00000MEiHSIA1",
    };

    const leadSourceDetailOnlyPlans = new Set([
        "collaboration",
        "enterprise_collab",
        "smb_services",
        "smb_3d_services",
        "smb_hero_section",
        "smb_how_it_works",
        "landing",
        "footer",
    ]);

    let selectedCampaignId = campaignMap["free_trial"];
    let plan = "default";
    let decodedRedirectURL = null;
    let plan_type = "default";

    if (state?.isMSP) {
        plan = plan_type = "MSP";
    }

    // we set URL to localstorage in case of Google Signin
    const encodedRedirectURL = localStorage.getItem("urlParams") || new URLSearchParams(window.location.search).get("redirectURL");
    localStorage.removeItem("urlParams")

    if (encodedRedirectURL) {
        decodedRedirectURL = decodeURIComponent(encodedRedirectURL);
        const redirectParams = new URLSearchParams(decodedRedirectURL.split("?")[1]);

        // make email as default campaign
        selectedCampaignId = campaignMap["email"];
        plan = redirectParams.get("plan") || "email";
        plan_type = redirectParams.get("plan_type") || "email";

        if (plan && campaignMap[plan]) {
            selectedCampaignId = campaignMap[plan];
        }

        if (decodedRedirectURL.includes("ai-asset-creator") || decodedRedirectURL.includes("ai-creator")) {
            plan = "ai-creator";
            selectedCampaignId = campaignMap["ai-creator"];
        }

        if (decodedRedirectURL.includes("pdp")) {
            selectedCampaignId = campaignMap["pdp"];
            plan_type = plan;
        }

        if (decodedRedirectURL.includes("starter_plus")) {
            selectedCampaignId = campaignMap["starter"];
            plan_type = "starter_plus";
        }

        if (decodedRedirectURL.includes("growth_plus")) {
            selectedCampaignId = campaignMap["growth"];
            plan_type = "growth_plus";
        }

        if (state?.isEnterprise) {
            selectedCampaignId = campaignMap["enterprise"];
        }

        if (leadSourceDetailOnlyPlans.has(plan_type)) {
            selectedCampaignId = campaignMap["free_trial"];
        }
    }

    const form = document.createElement("form");
    form.action = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
    form.method = "POST";
    form.target = "hidden_iframe";
    form.style.display = "none";

    const salesforcePayload = {
        oid: "00D8a000003i1AW",
        first_name: payload.first_name,
        last_name: payload.last_name,
        company: payload.company_name,
        email: payload.email,
        "00NUl00000BJq4e": payload?.company_size || "1-10",
        "00NUl000003nEMf": payload?.user_type || "Individual",
        "00NUl000003uZB6": plan_type || plan || "",
        description: "",
        lead_source: "Web Form",
        member_status: "Responded",
        Campaign_ID: selectedCampaignId || "",
        UTM_Source__c: state.utmSource
    };

    Object.entries(salesforcePayload).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
    });

    let iframe = document.getElementById("hidden_iframe");
    if (!iframe) {
        iframe = document.createElement("iframe");
        iframe.id = "hidden_iframe";
        iframe.name = "hidden_iframe";
        iframe.style.display = "none";
        document.body.appendChild(iframe);
    }

    document.body.appendChild(form);
    form.submit();

    setTimeout(() => {
        document.body.removeChild(form);
        console.log("Form submitted successfully without redirecting!");
    }, 1000);

};

export { submitToSalesForce };